import { ClientSettingsFilterResultsInfo } from "../model/reference/settingsTypes";

// A simplified version of ClientSettingsFilterResultsInfo for persisting to local storage
export class SimpleFilterResultsInfo {
  isSet: boolean;
  name: string;
  season: string;
  value: string;
  hasOptions: boolean;

  constructor(
    isSet: boolean,
    name: string,
    season: string | undefined | null,
    value: string,
    hasOptions: boolean,
  ) {
    this.isSet = isSet;
    this.name = name;
    this.season = season ?? "";
    this.value = value;
    this.hasOptions = hasOptions;
  }

  public static getNew(info: ClientSettingsFilterResultsInfo) {
    return new SimpleFilterResultsInfo(
      info.isSet ?? false,
      info.name,
      info.season,
      info.value,
      !!info.options?.length,
    );
  }
}
